import React, { useState, useEffect } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { Modal, Form, Button } from "react-bootstrap";
const AddressInfoDialog = (props) => {
    const {
        onClose,
        userObject: userObjectProp,

        open,
        // playerList,
        ...other
    } = props;


    const [address, setAddress] = useState(userObjectProp?.address);
    const [town, setTown] = useState(userObjectProp?.town);
    const [stateName, setStateName] = useState(userObjectProp?.stateName);
    const [country, setCountry] = useState(userObjectProp?.country);
    const [zipcode, setZipcode] = useState(userObjectProp?.zipCode);


    React.useEffect(() => {
        if (!open) {
            setAddress(userObjectProp?.address);
            setTown(userObjectProp?.town);
            setStateName(userObjectProp?.stateName);
            setCountry(userObjectProp?.country);
            setZipcode(userObjectProp?.zipCode);
        }
    }, [userObjectProp, open]);

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        // onClose(value, value1);
    };

    const handleChange = (event) => {
        //  setValue(event.target.value);
    };
    const handleChange1 = (event) => {
        // setValue1(c);
    };
    return (
        <Dialog
            sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
            maxWidth="xs"
            open={open}
            {...other}
        >
            <DialogTitle>Address Info </DialogTitle>
            <DialogContent dividers>
                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <TextField
                        id="filled-required"
                        variant="filled"
                        label="Address"
                        value={address}
                        onChange={(event) => {
                            setAddress(event.target.value);
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <TextField
                        id="filled-required"
                        variant="filled"
                        label="City"
                        value={town}
                        onChange={(event) => {
                            setTown(event.target.value);
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <TextField
                        id="filled-required"
                        variant="filled"
                        label="State"
                        value={stateName}
                        onChange={(event) => {
                            setStateName(event.target.value);
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <TextField
                        id="filled-required"
                        variant="filled"
                        label="ZipCode"
                        value={zipcode}
                        type="number"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={(event) => {
                            setZipcode(event.target.value);
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <TextField
                        id="filled-required"
                        variant="filled"
                        label="Country"
                        value={country}
                        onChange={(event) => {
                            setCountry(event.target.value);
                        }}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel}>
                    Cancel
                </Button>
                <Button onClick={handleOk}>Ok</Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddressInfoDialog